import { LocalStorageCapsule } from 'data-capsule';
let capsule;
const LOCAL_STORAGE_MESSAGE_KEY = 'page_message';
const resolveKey = async (key) => {
    const originalValue = await LocalStorage.getItem(key);
    await capsule.removeItem(key);
    const storageKeys = Object.keys(localStorage);
    await LocalStorage.setItem(key, originalValue);
    const updatedStorageKeys = Object.keys(localStorage);
    const newKeys = updatedStorageKeys.filter(storageKey => !storageKeys.includes(storageKey));
    return newKeys[0] ?? null;
};
export const LocalStorage = {
    setItem: async (key, value) => init() && capsule.setItem(key, JSON.stringify(value), { category: 'functional' }),
    getItem: async (key) => {
        if (init()) {
            try {
                return JSON.parse(await capsule.getItem(key));
            }
            catch { }
        }
        return null;
    },
    monitorItem: async (key, cb) => {
        if (!init()) {
            return null;
        }
        const resolvedKey = await resolveKey(key);
        // @ts-expect-error
        const handler = async ({ key: testKey, newValue }) => {
            if (testKey === resolvedKey) {
                try {
                    cb(JSON.parse(JSON.parse(newValue).value));
                }
                catch (e) {
                    console.error(e);
                }
            }
        };
        window.addEventListener('storage', handler);
        return () => {
            window.removeEventListener('storage', handler);
        };
    },
    sendMessage: async (type, payload) => LocalStorage.setItem(LOCAL_STORAGE_MESSAGE_KEY, { type, payload, time: Date.now() }),
    monitorMessage: async (type, cb) => {
        const value = await LocalStorage.getItem(LOCAL_STORAGE_MESSAGE_KEY);
        if (value?.type === type && (Date.now() - value.time) / 1000 < 10) {
            cb(value.payload);
        }
        return LocalStorage.monitorItem(LOCAL_STORAGE_MESSAGE_KEY, newValue => {
            if (newValue) {
                const { type: actualType, payload } = newValue;
                if (actualType === type) {
                    cb(payload);
                }
            }
        });
    },
    removeItem: async (key) => init() && capsule.removeItem(key),
};
const init = () => {
    try {
        if (!capsule) {
            const key = 'random-key6';
            window.localStorage.setItem(key, key);
            window.localStorage.removeItem(key);
            capsule = LocalStorageCapsule({ namespace: 'wix-events' });
        }
        return true;
    }
    catch (e) {
        return false;
    }
};
//# sourceMappingURL=local-storage.js.map